(function () {
  console.log("✅ Robust variant switcher installed");

  // find the main product form reliably
  function getProductForm() {
    // prefer the form inside <main> to avoid carousels/related products
    return document.querySelector('main form[action*="/cart/add"]')
        || document.querySelector('form[action*="/cart/add"]');
  }

  // set the variant id on both <select name="id"> and <input name="id">
  function setVariantIdOnForm(form, variantId) {
    let touched = false;

    // <select name="id">
    const sel = form.querySelector('select[name="id"]');
    if (sel) {
      // only set if this variant exists in options, otherwise theme may ignore it
      const hasOption = Array.from(sel.options).some(o => String(o.value) === String(variantId));
      if (hasOption) {
        if (sel.value !== String(variantId)) {
          sel.value = String(variantId);
          sel.dispatchEvent(new Event('input',  { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        touched = true;
      }
    }

    // hidden <input name="id">
    const hidden = form.querySelector('input[name="id"]');
    if (hidden && hidden.value !== String(variantId)) {
      hidden.value = String(variantId);
      hidden.dispatchEvent(new Event('input',  { bubbles: true }));
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
      touched = true;
    }

    // theme-level events some themes listen for
    form.dispatchEvent(new Event('variant:changed', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId }, bubbles: true }));

    return touched;
  }

  // try to click/select option controls by value so the theme recomputes the variant
  function setOptionsFromVariant(form, variant) {
    if (!variant || !Array.isArray(variant.options)) return;

    variant.options.forEach((value, i) => {
      const idx = i + 1;
      const escaped = CSS.escape(String(value));

      // radios
      const radio = form.querySelector(`input[type="radio"][name="options[${idx}]"][value="${escaped}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // selects
      const sel = form.querySelector(`select[name="options[${idx}]"]`);
      if (sel && sel.value !== String(value)) {
        sel.value = String(value);
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      // button/tile swatches (common patterns)
      const btn =
        form.querySelector(`[data-swatch-value="${escaped}"]`) ||
        form.querySelector(`[data-option-value="${escaped}"]`) ||
        form.querySelector(`[data-value="${escaped}"]`) ||
        form.querySelector(`[aria-label="${escaped}"]`) ||
        form.querySelector(`[title="${escaped}"]`);
      if (btn) {
        btn.click(); // let theme’s own JS run
      }
    });
  }

  // mark active left thumbnail (visual cue)
  function markActiveThumb(thumb) {
    const scroller = thumb.closest('[data-gallery-scroller]') || document;
    scroller.querySelectorAll('.product-gallery--media-thumbnail.is-active')
      .forEach(el => { el.classList.remove('is-active'); el.setAttribute('aria-pressed','false'); });
    const btn = thumb.closest('.product-gallery--media-thumbnail') || thumb;
    btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
  }

  // read product JSON (Empire exposes one of these)
  function getProductJson() {
    const el = document.querySelector('[type="application/json"][data-product-json], script[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.innerHTML || '{}'); }
    catch { return null; }
  }

  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-media-id]');
    if (!thumb) return;

    const variantId = thumb.getAttribute('data-variant-id');
    if (!variantId) return; // non-variant image (installation/collection)

    const form = getProductForm();
    if (!form) return;

    // also drive option controls (this usually makes the theme compute the variant)
    const product = getProductJson();
    const variant = product?.variants?.find(v => String(v.id) === String(variantId));
    if (variant) setOptionsFromVariant(form, variant);

    // set the id fields too (for themes that rely on it)
    setVariantIdOnForm(form, variantId);

    // update URL & UI hint
    try {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState(null, '', url.toString());
    } catch {}
    markActiveThumb(thumb);
  });
})();
